import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChatIcon from "@material-ui/icons/Chat";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import NewTicketModal from "../../components/NewTicketModal";
import { useTicketPopup } from "../../context/TicketPopup/TicketPopupContext";
import { tNegocio } from "./shared";

export function useCustomerChat() {
  const history = useHistory();
  const { openPopup } = useTicketPopup() || {};
  const [ticketContact, setTicketContact] = useState(null);
  const [busy, setBusy] = useState(false);

  const showTicket = (ticket, name) => {
    if (ticket?.uuid && typeof openPopup === "function") {
      openPopup({
        uuid: ticket.uuid,
        id: ticket.id,
        contact: { name: ticket.contact?.name || name || "" },
      });
      return;
    }
    if (ticket?.uuid) history.push(`/tickets/${ticket.uuid}`);
  };

  const openChat = async (customer) => {
    const contactId = customer?.contactId || customer?.id;
    if (!contactId || busy) return;
    setBusy(true);
    try {
      const { data } = await api.get(`/negocio/customers/${contactId}/open-ticket`);
      if (data?.ticket?.uuid) {
        showTicket(data.ticket, customer?.name);
        return;
      }
      setTicketContact({
        id: contactId,
        contactId,
        conversationSource: "customer",
        conversationId: contactId,
        name: customer.name,
        number: customer.number,
        telegram: customer.telegram,
        whatsappReachable: customer.whatsappReachable,
        phoneHidden: customer.phoneHidden,
      });
    } catch (e) {
      toastError(e);
    } finally {
      setBusy(false);
    }
  };

  const modal = ticketContact ? (
    <NewTicketModal
      modalOpen
      initialContact={ticketContact}
      onClose={(ticket) => {
        const name = ticketContact.name;
        setTicketContact(null);
        if (ticket?.uuid) showTicket(ticket, name);
      }}
    />
  ) : null;

  return { openChat, busy, modal };
}

export function ChatBubbleButton({ title, onClick, disabled, busy }) {
  return (
    <Tooltip title={title || tNegocio("pages.customers.newTicket")}>
      <span>
        <IconButton size="small" disabled={disabled || busy} onClick={onClick} style={{ padding: 4 }}>
          {busy ? (
            <CircularProgress size={18} />
          ) : (
            <span
              style={{
                width: 30,
                height: 30,
                borderRadius: 10,
                background: "linear-gradient(135deg, #25D366, #128C7E)",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(18,140,126,.45)",
              }}
            >
              <ChatIcon style={{ color: "#fff", fontSize: 18 }} />
            </span>
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
}

export function CustomerChatButton({ customer }) {
  const { openChat, busy, modal } = useCustomerChat();
  return (
    <>
      <ChatBubbleButton
        title={tNegocio("pages.customers.openChat")}
        busy={busy}
        onClick={(e) => {
          e.stopPropagation();
          openChat(customer);
        }}
      />
      {modal}
    </>
  );
}
